export const FILTERS = [
	//{ name: '', label: '' },
	{ value: 'contains', label: 'Contains' },
	{ value: 'notContains', label: 'Does not contain' },
	{ value: 'equals', label: 'Equals' },
	{ value: 'notEquals', label: 'Does not equal' },
	{ value: 'set', label: 'Is set' },
	{ value: 'notSet', label: 'Is not set' },
	{ value: 'gt', label: 'Greater than' },
	{ value: 'gte', label: 'Greater than equal' },
	{ value: 'lt', label: 'Less than' },
	{ value: 'lte', label: 'Less than equal' }
];
